import { createRoot } from 'react-dom/client';
import { CacheProvider } from '@emotion/react';
import { App } from './App';
import createEmotionCache from './emotionCache';
import './feedbackLoader';
// Dev-only: runtime scan for inline event handlers that violate CSP
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  import('./utils/scanInlineHandlers').then(({ scanInlineEventHandlers }) => {
    // Run after a small timeout so the app can mount and dynamic content exists
    setTimeout(() => scanInlineEventHandlers(), 3000);
  });
  import('./utils/scanObjectElements').then(({ scanObjectElements }) => {
    setTimeout(() => scanObjectElements(), 3000);
  });
  import('./utils/scanInlineScripts').then(({ scanInlineScripts }) => {
    setTimeout(() => scanInlineScripts(), 3000);
  });
}

const container = document.getElementById('root')!;
const root = createRoot(container); // createRoot(container!) if you use TypeScript
const cache = createEmotionCache();
// eslint-disable-next-line react/react-in-jsx-scope
root.render(
  <CacheProvider value={cache}>
    <App />
  </CacheProvider>
);

// Register the app service worker in production only.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}